"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var dsl_exports = {};
__export(dsl_exports, {
  empty: () => empty,
  fromColor: () => fromColor,
  fromColorFunc: () => fromColorFunc,
  fromColors: () => fromColors,
  gradient: () => gradient,
  hue: () => hue,
  invisible: () => invisible,
  lookup: () => lookup,
  mix: () => mix,
  numeric: () => numeric,
  ph: () => ph,
  quality: () => quality,
  standard: () => standard
});
module.exports = __toCommonJS(dsl_exports);
var import_color = __toESM(require("color"));
const FADE_LEVEL = 0.15;
function fromColorFunc(color, sizeMultiplier = 1, strokeMultiplier = 1) {
  return {
    normal: {
      size: 1 * sizeMultiplier,
      fillColor: (0, import_color.default)(color(true)).string(),
      strokeColor: (0, import_color.default)(color(false)).string(),
      strokeWidth: 1 * strokeMultiplier
    },
    selected: {
      size: 1.5 * sizeMultiplier,
      fillColor: (0, import_color.default)(color(true)).string(),
      strokeColor: (0, import_color.default)(color(false)).string(),
      strokeWidth: 2 * strokeMultiplier
    }
  };
}
function fromColor(baseColor, sizeMultiplier = 1, strokeMultiplier = 1) {
  const base = (0, import_color.default)(baseColor);
  return fromColorFunc((isFill) => isFill ? base : base.darken(0.4), sizeMultiplier, strokeMultiplier);
}
function fromColors(fillColor, strokeColor, sizeMultiplier = 1, strokeMultiplier = 1) {
  return fromColorFunc((isFill) => isFill ? fillColor : strokeColor, sizeMultiplier, strokeMultiplier);
}
const invisible = fromColorFunc(
  (isFill) => isFill ? (0, import_color.default)("transparent") : (0, import_color.default)("transparent"),
  0,
  0
);
const empty = fromColorFunc(
  (isFill) => isFill ? (0, import_color.default)("transparent") : (0, import_color.default)("rgba(128, 128, 128, .2)")
);
function hue(degrees) {
  return fromColorFunc((fill) => import_color.default.hsl(degrees % 360, 100, fill ? 60 : 40).fade(fill ? FADE_LEVEL : 0));
}
const standard = hue(60);
function lookup(value = 0) {
  return fromColorFunc(
    (fill) => import_color.default.hsl((50 * value + 180) % 360, 100, 40 + Math.floor(value / 10) * 5 % 30 + (fill ? 30 : 0)).fade(
      fill ? FADE_LEVEL : 0
    )
  );
}
function quality(value = 0.5) {
  const red = (lightness) => import_color.default.hsl(0, 100, lightness);
  const yellow = (lightness) => import_color.default.hsl(60, 100, lightness);
  const green = (lightness) => import_color.default.hsl(120, 100, lightness);
  const rescale = (value2, min, max) => (value2 - min) / (max - min);
  return fromColorFunc((fill) => {
    const lightness = fill ? 50 : 30;
    const base = value < 0.2 ? red(lightness * 0.65).mix(red(lightness), rescale(value, 0, 0.2)) : value < 0.5 ? red(lightness).mix(yellow(lightness), rescale(value, 0.2, 0.5)) : value < 0.75 ? yellow(lightness).mix(green(lightness), rescale(value, 0.5, 0.75)) : green(lightness).mix(green(lightness * 0.5), rescale(value, 0.75, 1));
    return base.fade(fill ? FADE_LEVEL : 0);
  });
}
function gradient(hue2, saturation, value = 0.5) {
  return fromColorFunc(
    (fill) => import_color.default.hsl(hue2, saturation * 100, fill ? 40 + 45 * value : 15 + 35 * value).fade(fill ? FADE_LEVEL : 0)
  );
}
function numeric(value, hue2 = 200, saturation = 1) {
  return gradient(hue2, saturation, value);
}
function mix(color1, color2, weight = 0.5) {
  return fromColor((0, import_color.default)(color1).mix((0, import_color.default)(color2), weight));
}
function ph(value) {
  return value < 1 ? fromColor("#e4222e") : value < 2 ? fromColor("#eb7831") : value < 3 ? fromColor("#f19932") : value < 4 ? fromColor("#f2bb33") : value < 5 ? fromColor("#f7d730") : value < 6 ? fromColor("#f3e934") : value < 7 ? fromColor("#c9d53e") : value < 8 ? fromColor("#aac556") : value < 9 ? fromColor("#7daaa1") : value < 10 ? fromColor("#4294c2") : value < 11 ? fromColor("#4582c0") : value < 12 ? fromColor("#426fb3") : value < 13 ? fromColor("#5e529f") : fromColor("#654598");
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  empty,
  fromColor,
  fromColorFunc,
  fromColors,
  gradient,
  hue,
  invisible,
  lookup,
  mix,
  numeric,
  ph,
  quality,
  standard
});
//# sourceMappingURL=dsl.js.map
